import { PrescriptionStatus, ActionStatus, LicenseStatus } from "../../types/data";

type StatusProps = {
  type: PrescriptionStatus | ActionStatus | LicenseStatus;
  count?: number;
  isCount?: boolean;
}

function Status({ type, count, isCount}: StatusProps) {
  const getColorIcon = (value: PrescriptionStatus | ActionStatus | LicenseStatus) => {
    if (value === 'В процессе') return '#F2A900';
    if (value === 'Закрыто' || value === 'Выполнено' || value === 'Действующий') return '#22AD5C';
    if (value === 'Просрочено' || value === 'Просрочен') return '#BA0C2F';
    if (value === 'Не начато' || value === 'В архиве') return '#DEE2E6';
    if (value === 'Нет действий') return '#FDE5D8';
  }

  const getColorText = (value: PrescriptionStatus | ActionStatus | LicenseStatus) => {
    if (value === 'В процессе') return '#F2A900';
    if (value === 'Закрыто' || value === 'Выполнено' || value === 'Действующий') return '#22AD5C';
    if (value === 'Просрочено' || value === 'Просрочен') return '#BA0C2F';
    if (value === 'Не начато' || value === 'Нет действий' || value === 'В архиве') return '#637381';
  }

  return (
    <div className="flex gap-2 items-center">
      <span className="w-2.5 h-2.5 rounded-full" style={{backgroundColor: getColorIcon(type)}}></span>
      <span style={{color: getColorText(type)}}>{type}</span>

      {isCount && <span style={{color: getColorText(type)}}>{count}</span>}
    </div>
  )
}

export default Status;
